import { useState } from "react";
import { calendarService, taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAttemptListItemResponseForWorkOrder } from "@miplatform/types";
import { getDate } from "@miplatform/utils";
import { useCalendarContext } from "../../../../../providers";
import { IAssignableUser } from "../../../NhcCalendar.types";

export const useAssignFromFollowUpModalViewModel = ({
  onClose,
  refreshData,
}: {
  onClose: () => void;
  refreshData: () => void;
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const { date, calendarSet } = useCalendarContext();
  const [assignableUsersAvailableTime, setAssignableUsersAvailableTime] =
    useState<IAssignableUser[]>([]);

  const bulkAssignAttempts = (data: IAttemptListItemResponseForWorkOrder[]) => {
    stateManager.run(async () => {
      const response = await taskService.attempts.bulkAssign({
        data,
        toastMessageConfig: {
          success: {
            text: "Work orders assigned successfully",
          },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        onClose();
        refreshData();
      }
    });
  };

  const getAssignableUsersAvailableTime = async () => {
    stateManager.run(async () => {
      const dateString = getDate(date).format("YYYY-MM-DD[T]00:00:00.0000000Z");
      const { data, status } =
        await calendarService.calendarSets.getAssignableUsersAvailableTime({
          id: calendarSet?.config.id,
          params: {
            date: dateString,
          },
        });
      if (status === HTTP_STATUSES.OK) {
        setAssignableUsersAvailableTime(
          data?.map((user: IAssignableUser) => ({
            id: user.id,
            availableTime: (user.availableTime ?? 0) / 3600,
          })) ?? []
        );
      }
    });
  };

  return {
    isLoading,
    assignableUsersAvailableTime,
    bulkAssignAttempts,
    getAssignableUsersAvailableTime,
  };
};
